import { render, staticRenderFns } from "./UserInfoCollection.vue?vue&type=template&id=57a84419&"
import script from "./UserInfoCollection.vue?vue&type=script&lang=js&"
export * from "./UserInfoCollection.vue?vue&type=script&lang=js&"
import style0 from "./UserInfoCollection.vue?vue&type=style&index=0&id=57a84419&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports